import { render, staticRenderFns } from "./com-extend.vue?vue&type=template&id=4ef62fbb&scoped=true"
import script from "./com-extend.vue?vue&type=script&lang=js"
export * from "./com-extend.vue?vue&type=script&lang=js"
import style0 from "./com-extend.vue?vue&type=style&index=0&id=4ef62fbb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef62fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef62fbb')) {
      api.createRecord('4ef62fbb', component.options)
    } else {
      api.reload('4ef62fbb', component.options)
    }
    module.hot.accept("./com-extend.vue?vue&type=template&id=4ef62fbb&scoped=true", function () {
      api.rerender('4ef62fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-extend.vue"
export default component.exports